module.exports = __webpack_public_path__ + "img/Surfing.f5b69583.png";